const _import = require("@/libs/util.import." + process.env.NODE_ENV)

export const routerName = {
  916: {
    path: "/accountCenter",
    name: "accountCenter",
    meta: {
      title: "账户中心",
      authId: "916",
      parentId: "1",
      cache: false
    }
  },
  91601: {
    path: "/account",
    name: "account",
    meta: {
      title: "账户类型列表",
      authId: "91601",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/account")
  },
  91602: {
    path: "/product",
    name: "product",
    meta: {
      title: "产品管理",
      authId: "91602",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/product")
  },
  91603: {
    path: "/menu",
    name: "menu",
    meta: {
      title: "菜单管理",
      authId: "91603",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/menu")
  },
  91604: {
    path: "/function",
    name: "function",
    meta: {
      title: "功能管理",
      authId: "91604",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/function")
  },
  91605: {
    path: "/dictionary",
    name: "dictionary",
    meta: {
      title: "字典管理",
      authId: "91605",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/dictionary")
  },
  91606: {
    path: "/merchant",
    name: "merchant",
    meta: {
      title: "商户管理",
      authId: "91606",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/merchant")
  },
  91607: {
    path: "/role",
    name: "role",
    meta: {
      title: "角色管理",
      authId: "91607",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/role")
  },
  91608: {
    path: "/employee",
    name: "employee",
    meta: {
      title: "员工管理",
      authId: "91608",
      parentId: "916",
      cache: false
    },
    component: _import("accountCenter/employee")
  }
}

